import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import Machine from "../components/Machine";

const MachinePage = () => {
    return (
        <Layout pageTitle="苏州卫捷 | 产品中心">
            <NavOne />
            <PageHeader title="产品中心" />
            <Machine />
            <Footer />
        </Layout>
    );
};

export default MachinePage;
